// extracted by mini-css-extract-plugin
export default {"root":"PaginationButtons_root__LGRBC","button":"PaginationButtons_button__9IS8E"};